export default __webpack_public_path__ + "static/brush-preview-40d05fff8301187c3e6695fff4990b64.gif";